import * as apiGet from 'api/identityProvider/GetIdentityProviderIdV1';
import * as apiPost from 'api/identityProvider/PostIdentityProviderV1';
import * as apiPut from 'api/identityProvider/PutIdentityProviderV1';

export default class IdentityProvider {
	public id: string = '';
	public name: string = '';
	public clientId: string = '';
	public clientAuthenticationRequired: boolean = true;
	public openIdConnectDiscoveryUrl: string = '';
	public propagateLogout: boolean = true;
	public useRefreshTokenForLogout: boolean = true;
	public mapRoles: boolean = false;
	public roleJsonPath: string = '';
	public iconSvg: apiGet.IconSvg | null = null;
	public sortOrder: number = 0;

	public clientSecret: string = '';

	public constructor(input?: apiGet.ResponseData) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiPut(iconSvgId: string | null): Promise<void> {
		await apiPut.callApi(this.id, this.mapToApiPut(iconSvgId));
	}

	public async callApiPost(iconSvgId: string | null): Promise<void> {
		const response = await apiPost.callApi(this.mapToApiPost(iconSvgId));
		response.hasValue() && this.mapFromApiPost(response.get());
	}

	private mapToApiPost(iconSvgId: string | null): apiPost.Request {
		return {
			clientId: this.clientId,
			name: this.name,
			clientAuthenticationRequired: this.clientAuthenticationRequired,
			clientSecret: this.clientSecret,
			openIdConnectDiscoveryUrl: this.openIdConnectDiscoveryUrl,
			propagateLogout: this.propagateLogout,
			useRefreshTokenForLogout: this.useRefreshTokenForLogout,
			mapRoles: this.mapRoles,
			roleJsonPath: this.roleJsonPath,
			iconSvgId: iconSvgId ?? this.iconSvg?.id ?? null,
			sortOrder: this.sortOrder,
		};
	}

	private mapToApiPut(iconSvgId: string | null): apiPut.Request {
		return {
			clientId: this.clientId,
			name: this.name,
			clientAuthenticationRequired: this.clientAuthenticationRequired,
			clientSecret: this.clientSecret,
			openIdConnectDiscoveryUrl: this.openIdConnectDiscoveryUrl,
			propagateLogout: this.propagateLogout,
			useRefreshTokenForLogout: this.useRefreshTokenForLogout,
			mapRoles: this.mapRoles,
			roleJsonPath: this.roleJsonPath,
			iconSvgId: iconSvgId ?? this.iconSvg?.id ?? null,
			sortOrder: this.sortOrder,
		};
	}

	private mapFromApi(input: apiGet.ResponseData) {
		this.id = input.id;
		this.name = input.name;
		this.clientId = input.clientId;
		this.clientAuthenticationRequired = input.clientAuthenticationRequired;
		this.openIdConnectDiscoveryUrl = input.openIdConnectDiscoveryUrl;
		this.propagateLogout = input.propagateLogout;
		this.useRefreshTokenForLogout = input.useRefreshTokenForLogout;
		this.mapRoles = input.mapRoles;
		this.roleJsonPath = input.roleJsonPath;
		this.iconSvg = input.iconSvg;
		this.sortOrder = input.sortOrder;
	}

	private mapFromApiPost(input: string) {
		this.id = input;
	}
}
